module.exports = __webpack_public_path__ + "static/media/twitter.2107db1a.png";